
import React, { useState } from 'react';
import DeviceRegistrationTabs from './DeviceRegistrationTabs';
import RegisterDeviceCard from './RegisterDeviceCard';
import ManageDevicesCard from './ManageDevicesCard';
import { Button } from '@/components/ui/button';

const DeviceRegistration = () => {
  const [activeTab, setActiveTab] = useState('manage');

  const handleRegisterNewClick = () => {
    setActiveTab('register');
  };

  const handleRegistrationComplete = () => {
    setActiveTab('manage');
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">Device Registration</h2>
          <p className="text-muted-foreground">
            Register and manage IoT devices for energy, gas, and water monitoring systems.
          </p>
        </div>
        {activeTab === 'manage' && (
          <Button onClick={handleRegisterNewClick}>
            Register New Device
          </Button>
        )}
      </div>
      
      <DeviceRegistrationTabs
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        registerContent={<RegisterDeviceCard onComplete={handleRegistrationComplete} />}
        manageContent={<ManageDevicesCard onRegisterNew={handleRegisterNewClick} />}
      />
    </div>
  );
};

export default DeviceRegistration;
